import type { InputMultiSelectProps } from '../../input-multi-select.types'

export function useSelectedOptions(
  selectedOptions: InputMultiSelectProps['options']
) {
  const selectedOptionsCount = selectedOptions.length
  const isFilled = selectedOptionsCount > 0

  const hiddenOptionsCount = selectedOptionsCount - 3

  return {
    isFilled,
    hiddenOptionsCount,
  }
}
